// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"746":"b946ce7b","868":"83ae5572"}[chunkId] + ".chunk.css";
};